export function getDomainConfigValue(key) {
  return window.domainConfig ? window.domainConfig[key] : undefined;
}
